import { AnswerQueryInterface } from '@types';
import { Pagination } from '@components/Pages/AnswersPage/constants';
import { AnswerSortEnum, AnswersStatus, LangEnum } from '@enums';

export type AnswersPageState = {
  isOpenAnswersDeleteModal: boolean;
  isOpenMarkAsSentModal: boolean;
  filters: AnswerQueryInterface;
};

export const initialAnswerFilters: AnswerQueryInterface = {
  offset: 0,
  limit: Pagination.ANSWERS_ON_PAGE_COUNT_FIRST,
  status: [AnswersStatus.NEW, AnswersStatus.DELAYED, AnswersStatus.EDITED, AnswersStatus.EXPIRED],
  lang: LangEnum.ALL,
  order: [AnswerSortEnum.createdAt_DESC],
};

export const answersPageInitialState: AnswersPageState = {
  isOpenAnswersDeleteModal: false,
  isOpenMarkAsSentModal: false,
  filters: initialAnswerFilters,
};
